// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Diamond20FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Diamond20Filled: FC<Diamond20FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="m4.448 5-1.77-1.77L3.74 2.166l1.77 1.77L4.448 5ZM9.26 3.5V1h1.5v2.5h-1.5ZM15.552 5 14.49 3.937l1.77-1.77 1.063 1.062L15.553 5ZM10.01 17l-6.333-6.5h12.667L10.01 17Zm-3-12h6l3.313 4H3.698L7.01 5Z" />
        </svg>
    );
};

export default Diamond20Filled;
